import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig";
import TripPlayer from "./TripPlayer";

const TripViewerPage = () => {
  const [deviceId, setDeviceId] = useState(null);
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDeviceId = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const plateNumber = params.get("plate");
        const fromParam = params.get("from");
        const toParam = params.get("to");

        // Validate query parameters
        if (!plateNumber || !fromParam || !toParam) {
          setError("Missing required parameters: plate, from, or to.");
          setLoading(false);
          return;
        }

        const fromTimestamp = Number(fromParam);
        const toTimestamp = Number(toParam);

        if (isNaN(fromTimestamp) || isNaN(toTimestamp)) {
          setError("Invalid date range parameters.");
          setLoading(false);
          return;
        }

        if (fromTimestamp >= toTimestamp) {
          setError("From date must be before to date.");
          setLoading(false);
          return;
        }

        if (toTimestamp > Math.floor(Date.now() / 1000)) {
          setError("To date cannot be in the future.");
          setLoading(false);
          return;
        }

        // Fetch deviceId from Firestore
        const vehiclesRef = collection(db, "vehicles");
        const q = query(vehiclesRef, where("plateNumber", "==", plateNumber));
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
          setError("No vehicle found with the provided plate number.");
          setLoading(false);
          return;
        }

        const vehicleDoc = querySnapshot.docs[0];
        const vehicleData = vehicleDoc.data();
        if (!vehicleData.deviceId) {
          setError("Vehicle found but no device ID associated.");
          setLoading(false);
          return;
        }

        console.log("Fetched vehicle data:", vehicleData); // Debug log
        setDeviceId(vehicleData.deviceId);
        setFrom(fromTimestamp);
        setTo(toTimestamp);
      } catch (err) {
        console.error("Error fetching vehicle:", err);
        setError("Failed to fetch vehicle data. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchDeviceId();
  }, [location.search]);

  if (loading) {
    return <div style={{ padding: "20px" }}>⏳ Loading trip data...</div>;
  }

  if (error) {
    return <div style={{ padding: "20px", color: "red" }}>❌ {error}</div>;
  }

  return (
    <div>
      <button
        onClick={() => navigate("/dashboard")}
        style={{ margin: "10px" }}
      >
        Back to Dashboard
      </button>
      <TripPlayer deviceId={deviceId} from={from} to={to} />
    </div>
  );
};

export default TripViewerPage;